export const LEAD_ERROR_CODE = {
	WRONG_SMS_CODE: 'wrong_sms_code',
	CODE_EXPIRED: 'code_expired',
	NOT_ACTIVATED: 'not_activated',
	STATE_INVALID: 'state_invalid',
	CREATE_TIMEOUT: 'create_timeout',
	LINK_EXPIRED: 'link_expired',
	SMS_TIMEOUT: 'sms_timeout',
	NO_FIND_ORDER: 'no_find_order',
	COULDNT_FIND_RBIDOS_LEAD: "couldn't find rbidos::lead",
	FUNCTION_UNAVAILABLE: 'function_unavailable',
	TOO_MANY_ATTEMPTS: 'too_many_attempts',
	NOT_FOUND: 'not_found',
	LEAD_COMPETE: 'lead_compete',
	UNKNOWN: 'unknown',
	ATTEMPTS_EXCEEDED: 'attempts_exceeded',
	SMS_TIMER: 'sms_timer',
}

export const ERROR_LEAD_CODE_TRANSLATE = {
	[LEAD_ERROR_CODE.WRONG_SMS_CODE]: 'Неверный код смс',
	[LEAD_ERROR_CODE.CODE_EXPIRED]: 'Истёк срок действия кода (15 минут)',
	[LEAD_ERROR_CODE.NOT_ACTIVATED]: 'Ошибка создания заявки. Обратитесь в техническую поддержку',
	[LEAD_ERROR_CODE.STATE_INVALID]: 'Ссылка уже была использована ранее',
	[LEAD_ERROR_CODE.CREATE_TIMEOUT]: 'Отправка смс возможна 1 раз в 3 минуты',
	[LEAD_ERROR_CODE.LINK_EXPIRED]: 'Истёк срок действия ссылки (5 минут)',
	[LEAD_ERROR_CODE.SMS_TIMEOUT]: 'Отправка повторной смс возможна 1 раз в 3 минуты',
	[LEAD_ERROR_CODE.NO_FIND_ORDER]: 'Заявка не найдена',
	[LEAD_ERROR_CODE.COULDNT_FIND_RBIDOS_LEAD]: "couldn't find rbidos::lead",
	[LEAD_ERROR_CODE.FUNCTION_UNAVAILABLE]:
		'Функция не доступна. Обратитесь в техническую поддержку.',
	[LEAD_ERROR_CODE.TOO_MANY_ATTEMPTS]:
		'Вы превысили количество попыток ввода кода. Для получения новой ссылки',
	[LEAD_ERROR_CODE.NOT_FOUND]: 'Страница не найдена',
	[LEAD_ERROR_CODE.UNKNOWN]: 'Вы перешли по устаревшей ссылке или есть запрет на регистрацию',
}

export const SECOND_LIMIT_TIMER_LEAD = 180
